export default __webpack_public_path__ + "static/media/img_6.bd0bc77a.jpg";